import { useTranslation } from "react-i18next";

const socialLinks = [
  { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/301mgmt" },
  { icon: "ri-linkedin-line", label: "LinkedIn", href: "https://www.linkedin.com/company/301mgmt" },
];

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="text-white py-6" style={{ backgroundColor: "#0d0b1e" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} {t("footer.brand")}. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-white/10 hover:border-brand-pink hover:bg-brand-pink/10 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm text-white/40 hover:text-white`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}